import { getDefaultDescription } from '@shared/prosemirror/getDefaultDescription';
import { createState } from '@store/utils/createState';
import { atom } from 'jotai';

import { type Role } from './types';

export const initialState = (): Role => ({
  id: '',
  name: '',
  description: getDefaultDescription(),
  organizationId: '',
  createdAt: '',
  updatedAt: '',
});

export const {
  state: meRoleState,
  listState: meRolesState,
  idsState: meRoleIdsState,
} = createState({ initialState });

export const meRolesNamesAtom = atom<string[]>((get) => {
  const roles = get(meRolesState);

  return roles.map((role) => role.name);
});
